// extracted by mini-css-extract-plugin
export var actionButton = "_iw-0";
export var fileInput = "_iw-2";
export var paperclip = "_iw-1";